module.exports = __webpack_public_path__ + "static/media/open-case.e90f7330.svg";